import _ from 'lodash'
import { Timestamp } from 'types'
import { ApiV1Response, http } from './http'

export interface AnnouncementData {
  id: number // 1
  title: string // "announcement title"
  content: string // "announcement content"
  publishTime: Timestamp // 1687428596000
  category: number // 0
  link: string // ""
  expirationDate: Timestamp // 1687428596000
}
export async function getLatestAnnouncement<
  T extends ApiV1Response<AnnouncementData>
>() {
  const r = await http.get<T>(`/message/announcement/last`)
  return r.data
}

export enum NotificationReadStatus {
  All,
  Unread,
  Read,
}
export enum NotificationType {
  TRADE = 1,
  FUND_CHANGE,
  ACTIVITY,
  SYSTEM,
}
export enum NotificationStatus {
  Successful,
  Failed,
  Pending,
}
export interface Notification {
  id: number
  userId: number
  title: string
  content: string
  messageType: NotificationType
  messageStatus: NotificationStatus
  link: string
  isRead: boolean
  createTime: number
}
export interface NotificationResponse {
  records: Notification[]
  total: number // record total number
  size: number // page limit
  current: number // page index
  // orders: []
  // optimizeCountSql: boolean
  // searchCount: boolean
  // maxLimit: null
  // countId: null
  // pages: number
}
export async function getNotification<
  T extends ApiV1Response<NotificationResponse>
>(page: number, size: number = 10, status = NotificationReadStatus.All) {
  const r = await http.get<T>(`/message/account/page`, {
    params: { current: page, size, status },
  })
  return r.data
}

export interface postReadNotificationBody {
  ids?: number[]
  isAllRead?: boolean
}
export interface DeleteNotificationBody {
  ids?: number[]
  isAllRemove?: boolean
}
export async function postReadNotification<T extends ApiV1Response<boolean>>(
  ids: number[] | true
) {
  const body: postReadNotificationBody = {
    isAllRead: false,
  }
  if (ids === true) {
    body.isAllRead = true
  } else if (_.isArray(ids)) {
    body.ids = ids
  } else {
    return false
  }

  const r = await http.post<T>(`/message/account/read`, body)
  return r.data
}

export async function deleteNotification<
  T extends ApiV1Response<boolean>
>(params: { ids?: number[]; isAllRemove?: boolean }) {
  const { ids, isAllRemove } = params

  const body: DeleteNotificationBody = {}
  if (ids) {
    body.ids = ids
  } else if (_.isBoolean(isAllRemove)) {
    body.isAllRemove = isAllRemove
  }

  const r = await http.delete<T>(`/message/account/remove`, {
    data: body,
  })
  return r.data
}
